import FileVM from './file-vm';
import QuestionPresenter from './question-presenter';
import HostedMediaMonitor from './media-monitors/hosted';
import NativeMediaMonitor from './media-monitors/native';
import StaticMediaMonitor from './media-monitors/static';
import IframeRenderer from 'libs/iframe-renderer';
import IframeDocumentRenderer from 'libs/iframe-document-renderer';
import ImageMediaRenderer from 'libs/image-media-renderer';
import DICOMMediaRenderer from 'libs/dicom-media-renderer';
import LoginModal from 'libs/login-modal';
export default function() {
  var self = this;

  self.currentVideo = null;

  self.media = ko.observableArray();
  self.attachments = ko.observableArray();
  self.selectedResource = ko.observable();

  self.nativeRenderer;

  self.volume = 1;
  self.rate = 1;
  self.fullscreen;

  self.userStateData = {};

  self.currentMediaIndex = 0;
  self.autoplay = false;

  self.current_modal = null;
  self.shareEmails = ko.observable();

  var videoClick = function( data ) {
    console.log( 'videoClick', data);
    return false;
  };

  self.videoDuration = function(seconds) {
    var timeStr = '';
    if(seconds) {
      seconds = Math.round(seconds);
      console.log( 'seconds', seconds );
      var t = new Date(1970,0,1);
      t.setSeconds(seconds);
      timeStr = t.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1');
    }
    return timeStr;
  };

  var findUnplayedLecture = function() {
    var queuedVideos = [];
    var completedVideos = [];
    var nextToPlay;

    _.each(self.media(),function(vid){
      if(vid.completed()) {
        completedVideos.push(vid);
      }
    });

    if(completedVideos.length > 0) {
      var maxOrderComplete = _.max(completedVideos, function(vid){ return vid.order(); });
      // find incomplete videos after the last one completed (don't want to watch skipped vid)
      _.each(self.media(),function(vid){
        if(!vid.completed() && (vid.order() > maxOrderComplete.order())) {
          queuedVideos.push(vid);
        }
      });

      // queuedVideos are videos that haven't been watched and are after last completed
      // so that if a user skips a video (eg the introduction), it doesn't always play
      if(queuedVideos.length > 0) {
        nextToPlay = _.min(queuedVideos, function(vid){ return vid.order(); });

        if(self.media().length > queuedVideos.length) {
          self.autoplay = true;
          // order - 1 because the videos are 0 index
          return self.currentMediaIndex = nextToPlay.order();
        }
      } else {
        // there may be skipped videos or all videos have been watched
        self.autoplay = false;

        // check for skipped videos
        var skippedVideos = [];
        _.each(self.media(),function(vid){
          if(!vid.completed()) {
            skippedVideos.push(vid);
          }
        });

        if(skippedVideos.length > 0) {
          // set to the first skipped video
          nextToPlay = _.min(skippedVideos, function(vid){ return vid.order(); });
          return self.currentMediaIndex = nextToPlay.order();
        } else {
          // there are no skipped videos so we reset to the first video
          return self.currentMediaIndex = 0;
        }
      } // end check for skipped videos
    } else {
      // no videos watched yet
      self.autoplay = false;
      return self.currentMediaIndex = 0;
    }

    return false;
  };

  //plays lectures in a sequence
  var showNextLecture = function() {
    // find unplayed lecture will determine if the video should be autoplayed,
    // and which should be the first video played
    findUnplayedLecture();
    self.previousType = self.currentVideo && self.currentVideo.type();
    self.currentVideo = self.media()[self.currentMediaIndex];
    document.querySelector('#vid-player').classList.remove(self.previousType);
    document.querySelector('#vid-player').classList.add(self.currentVideo.type());

    // Update state of queue
    updateActiveState(self.currentVideo);

    showVideo(self.currentVideo);

    if (!self.currentVideo.accessible()) {
      resetVideoSrcs(self.currentVideo);
      return;
    }

    if (self.currentVideo.type() == 'NativeMedia') {
      var renderer = self.nativeRenderer.play(self.autoplay, function() {});
      var _listener = function(){
        self.currentVideo.active(false);
        self.currentVideo.completed(true);
        self.currentVideo.monitor.processQueue(() => {
          self.currentMediaIndex += 1;
          showNextLecture();
        });
      };

      var i = renderer.events.ended && renderer.events.ended.length || 0;
      while (i--) {
        renderer.removeEventListener('ended', renderer.events.ended[i]);
      }
      renderer.addEventListener('ended', _listener);
    }
    return false;
  };

  var showVideo = function(vid) {

    var hideRenderer = function() {
      if(self.currentVideo.renderer && self.currentVideo.renderer.presented) {
        self.currentVideo.renderer.hide();
      }
    };

    var hideHosted = function() {
      if(!_.isUndefined(self.currentVideo.hostedRenderer)){
        self.currentVideo.hostedRenderer.hide();
      }
    };

    if(self.currentVideo) {
      if (_.includes(['DocumentMedia', 'IframeMedia', 'ImageMedia', 'DICOMMedia'], self.currentVideo.type())) {
        hideRenderer();
      } else if (self.currentVideo.type() == 'HostedVideo') {
        hideHosted();
      }
    }

    self.currentVideo = vid;
    self.currentVideo.active(true);
    $('.vjs-unlocked-modal').show();

    if (!vid.accessible()) {
      // Show locked state modal, might need to force pause to original video doesn't play
      resetVideoSrcs(vid);
      return false;
    }

    if(vid.type() == 'NativeMedia') {
      cleanupNativeRenderer();
      self.nativeRenderer.setMetaReady(false);
      if(!self.nativeRenderer.shown())
        self.nativeRenderer.show();
      delete vid.questions_presenter;

      if (self.user_type == 'enrolled') {
        vid.questions_presenter = new QuestionPresenter(self.nativeRenderer, vid.media_cues, vid.tracking_data);
        vid.questions_presenter && vid.questions_presenter.present();
      }

      var mediaSrcUrls = {
        h264_360_url: vid.h264_360_url ? vid.h264_360_url() : '',
        h264_720_url: vid.h264_720_url ? vid.h264_720_url() : ''
      };

      self.nativeRenderer.setMediaSrcUrls(mediaSrcUrls);

      _.each(vid.subtitles(),function(v){
        self.nativeRenderer.addTextTrack(ko.toJS(v));
      });

      setupUserState();

    } else if (vid.type() == 'HostedVideo') {
      if (self.nativeRenderer)
        self.nativeRenderer.hide();

      vid.hostedRenderer.show();
    } else if(_.includes(['DocumentMedia', 'IframeMedia', 'ImageMedia', 'DICOMMedia'], vid.type())) {

      if(self.nativeRenderer)
        self.nativeRenderer.hide();

      if(!vid.renderer.presented)
        vid.renderer.present();

      vid.renderer.show();
    }

    // Maintain/exit/change full screen depending on the media renderer/type
    handleFullscreenState(vid, self.nativeRenderer);
  };

  self.downloadAllMediaMobileApp = function() {
    ga('send', {
      hitType: 'event',
      eventCategory: 'lecture',
      eventAction: 'download_all',
      eventLabel: self.trackingData().lecture.title
    });

    _.each(self.media(),function(vid) {
      if(vid.type() == 'NativeMedia') {
        self.downloadMediaMobileApp(vid);
      }
    });
  };

  self.downloadMediaMobileApp = function(vid) {
    console.log('Download Media...', vid);
    var message = {
      course_id: self.trackingData().course.id,
      course_name: self.trackingData().course.name,
      course_thumbnail: self.trackingData().course.logo_thumb,
      lecture_id: self.trackingData().lecture.id,
      lecture_name: self.trackingData().lecture.title,
      lecture_order: self.trackingData().lecture.order,
      media_id: vid.id(),
      media_type: vid.type(),
      media_title: vid.title(),
      media_size: vid.size(),
      media_src_high: vid.h264_360_url ? vid.h264_360_url() : '',
      media_src_low: vid.h264_720_url ? vid.h264_720_url() : '',
      media_order: vid.order(),
      media_thumbnail: vid.media_src.thumb.url()
    };

    ga('send', {
      hitType: 'event',
      eventCategory: 'lecture_media',
      eventAction: 'download',
      eventLabel: vid.title()
    });

    if (window.webkit) {
      window.webkit.messageHandlers.downloadMediaHandler.postMessage(message);
    }
  };

  var cleanupNativeRenderer = function() {
    if (self.currentVideo && self.currentVideo.questions_presenter) {
      self.currentVideo.questions_presenter.cleanup();
    }

    //Hack to clear timeupdate event listeners to ensure quiz questions are cleared
    _.each(self.nativeRenderer.events.timeupdate, function(el, idx) {
      self.nativeRenderer.removeEventListener('timeupdate', el);
    });

    self.nativeRenderer.clearTextTracks();
  };

  self.onMediaClick = function(e) {
    if (!e.accessible()) {
      // We want to force the locked modal state here..
      resetVideoSrcs(e);
      return;
    }

    self.previousType = self.currentVideo && self.currentVideo.type();

    // This is to handle the enteryKey binding, 'this' is the viewModel we want
    if (_.isUndefined(e)) e = this;

    self.currentMediaIndex = undefined;

    // Update state of queue
    updateActiveState(e);

    //activate clicked video
    showVideo(e);

    if (e.type() == 'NativeMedia') {
      var renderer = self.nativeRenderer.play(true, function(){});

      var _listener = function(){
        e.active(false);
        e.completed(true);
        self.currentMediaIndex += 1;
        showNextLecture();
      };

      var i = renderer.events.ended.length;

      while (i--) {
        renderer.removeEventListener('ended', renderer.events.ended[i]);
      }

      renderer.addEventListener('ended', _listener);
    } else {
      if(self.nativeRenderer && _.isFunction(self.nativeRenderer.stop))
        self.nativeRenderer.stop();

      if (e.type() == 'ImageMedia' ||
            e.type() == 'DocumentMedia' ||
              e.type() == 'DICOMMedia' ||
                e.type() == 'IframeMedia') {
        e.completed(true);
        self.currentMediaIndex += 1;
      }
    }

    document.querySelector('#vid-player').classList.remove(self.previousType);
    document.querySelector('#vid-player').classList.add(e.type());

    return false;
  };

  var updateActiveState = function(video) {
    //set all videos to active(false) first
    _.each(self.media(), function(v,i){
      if(v.active() === true) {
        if(v.type()==='HostedVideo' && !_.isUndefined(v.hostedRenderer)) {
          v.hostedRenderer.pause();
        }
        v.active(false);
      }
    });
  };

  var handleFullscreenState = function(media, nativeRenderer) {
    if(media.type() != 'NativeMedia' && nativeRenderer && nativeRenderer.isFullscreen()) {
      nativeRenderer.exitFullscreen();
    }
  };

  var initializeDefaults = function(vids, cb) {
    self.id = $('#lecture_id').val();
    self.course_id = $('#course_id').val();
    self.user_type = $('#user_type').val();
    self.premium_member = $('#premium_member').val();
    self.user_id = $('#current_user').val();

    $.each(vids(), function(idx, vid) {
      vid.index = idx;
      vid.order = ko.observable(idx);
      vid.active = ko.observable(false);
      if(!vid.title() && vid.document_conversion_job && vid.document_conversion_job.previewable_file)
        vid.title = ko.observable(vid.document_conversion_job.previewable_file.name());
      vid.monitor = null;
      vid.tracking_data = { session_media: { id: vid.id(), title: vid.title(), session_id: vid.lecture_id(), order: vid.order() } };

      self.userStateData = ko.toJS(vid.user_state_data);
      var media_id = vid.id();

      var $vidWrapper = $('#vid-player');

      // Skip binding players if they aren't playable
      if (!vid.accessible()) {
        return true;
      }

      if (vid.type() == 'HostedVideo') {
        var url = vid.media_src();
        vid.hostedRenderer = new Kadenze.IframeMediaPlayer($vidWrapper, url, self.userStateData, false);
        vid.monitor = new HostedMediaMonitor(self.user_id, self.user_type, vid, vid.hostedRenderer);
      } else if(vid.type() == 'NativeMedia') {
        initializeNativeRenderer(vid, cb);
      } else if(vid.type() == 'DocumentMedia') {
        var media_id = undefined;
        var media_s3_data = {}

        if (vid.media_s3_url()) {
          media_s3_data = {
            id: vid.id(),
            download: vid.media_s3_url(),
            anchor: vid.media_s3_url(),
            title: vid.title(),
            type: vid.type()
          }
          console.log('Using S3 URL for Document Media.');
        } else {
          media_id = vid.document_conversion_job.id()
        }

        vid.tracking_data.type = vid.type();
        vid.renderer = new IframeDocumentRenderer({
          id: media_id,
          media_s3_data: media_s3_data,
          $container: $vidWrapper, style: { position: 'absolute' }
        });
        vid.monitor = new StaticMediaMonitor(self.user_id, self.user_type, vid, vid.renderer);

      } else if(vid.type() == 'IframeMedia') {
        vid.tracking_data.type = vid.type();
        vid.renderer = new IframeRenderer({ frame: vid.sanitized_alternate_src(), $container: $vidWrapper, style: { position: 'absolute', maxWidth: '100%', maxHeight: '100%' } });
        vid.monitor = new StaticMediaMonitor(self.user_id, self.user_type, vid, vid.renderer);
      } else if (vid.type() == 'ImageMedia') {
        vid.tracking_data.type = vid.type();
        if (vid.media_s3_url()) {
          vid.renderer = new ImageMediaRenderer({ src: vid.media_s3_url(), $container: $vidWrapper, style: { position: 'relative', maxWidth: '100%', maxHeight: '100%' } });
        } else {
          vid.renderer = new ImageMediaRenderer({ src: vid.media_src.url(), $container: $vidWrapper, style: { position: 'relative', maxWidth: '100%', maxHeight: '100%' } });
        }
        vid.monitor = new StaticMediaMonitor(self.user_id, self.user_type, vid, vid.renderer);
      } else if (vid.type() == 'DICOMMedia') {
        vid.tracking_data.type = vid.type();
        vid.renderer = new DICOMMediaRenderer({ src: vid.media_src.url(), $container: $vidWrapper, style: { position: 'absolute' } });
        vid.monitor = new StaticMediaMonitor(self.user_id, self.user_type, vid, vid.renderer);
      }

    });

    if(_.isUndefined(self.nativeRenderer) || _.isNull(self.nativeRenderer)) {
      cb();
    }
  };

  // This pertains to native videos only
  var initializeNativeRenderer = function(vid, readyCb) {
    if (!self.nativeRenderer) {
      var $vidWrapper = $('#vid-player');
      var initialVids = {
        h264_360_url: vid.h264_360_url ? vid.h264_360_url() : '',
        h264_720_url: vid.h264_720_url ? vid.h264_720_url() : ''
      };

      var initialSubs = ko.toJS(vid.subtitles);

      var nativeRendererOpts;
      if (self.premium_member == 'true') {
        nativeRendererOpts = { volume: self.volume };
      } else if (self.user_type == 'enrolled') {
        nativeRendererOpts = {volume: self.volume, user_type: self.user_type, displayMode: 'session', ctaCallback: self.upgradeUser };
      } else {
        nativeRendererOpts = {volume: self.volume, user_type: self.user_type, displayMode: 'session', ctaCallback: self.enrollInCourse };
      }

      self.nativeRenderer = new Kadenze.VideoPlayer($vidWrapper, initialVids, 'vjs-student-skin', initialSubs, self.userStateData, nativeRendererOpts);

      self.nativeRenderer.addEventListener('volumechange',function(obj) {
        console.log('volumechange');
        self.volume = obj.target.volume();
      });

      self.nativeRenderer.addEventListener('ratechange',function(obj) {
        // the following is necessary because firefox fires a ratechange event when it first loads a video :-/
        console.log('ratechange');
        self.rate = obj.target.playbackRate();
      });

      self.nativeRenderer.addEventListener('playing', function(player) {
        console.log('playing');
        player.target.setVolume(self.volume);
        player.target.setPlaybackRate(self.rate);
      });

      self.nativeRenderer.addEventListener('fullscreenchange',function(obj) {
        if(self.fullscreen === true) {
          self.fullscreen = false;
        } else {
          self.fullscreen = true;
        }
      });

      self.nativeRenderer.addEventListener('skipForward', function(event) {
        self.currentMediaIndex += 1;
        showNextLecture();
      });

      self.nativeRenderer.addEventListener('skipBack', function(event) {
        if(self.currentMediaIndex <= 0) return;
        self.currentMediaIndex -= 1;
        showNextLecture();
      });

      self.nativeRenderer.addEventListener('ready', readyCb);
    }

    // Tracking of the native renderer, this is where we report the state of currently active native video only
    vid.monitor = new NativeMediaMonitor(self.user_id, self.user_type, vid, self.nativeRenderer, self);

  };

  var setupUserState = function() {
    var nativeRenderer = self.nativeRenderer;
    var userState = nativeRenderer ? nativeRenderer.user_state : null;
    if(userState) {
      if(userState.resolution) {
        nativeRenderer.setResolution(userState.resolution);
      }

      if(userState.volume) {
        nativeRenderer.setVolume(userState.volume);
      }

      if(userState.textTrackSettings) {
        nativeRenderer.setTextTrackSettings(userState.textTrackSettings);
      }

      if(userState.playback_rate) {
        nativeRenderer.setPlaybackRate(userState.playback_rate);
      }

      if(userState.caption_language) {
        nativeRenderer.setCaptionLanguage(userState.caption_language);
      }
    }
  };

  var resetVideoSrcs = function(currentMedia) {
    if(!_.isUndefined(self.nativeRenderer)) {
      var mediaSrcUrls = {
        h264_360_url: '',
        h264_720_url: ''
      };
      self.nativeRenderer.setMediaSrcUrls(mediaSrcUrls);
      $('.vjs-unlocked-modal').addClass('vjs-hidden vjs-modal-hidden');
      $('.vjs-error-display').hide();
      if (currentMedia.premium_only() && self.user_type == 'enrolled') {
        $('.vjs-premium-locked-modal').removeClass('vjs-hidden vjs-modal-hidden');
      } else {
        $('.vjs-locked-modal').removeClass('vjs-hidden vjs-modal-hidden');
      }
    }
  };

  self.getCurrentMedia = function() {
    return self.media()[self.currentMediaIndex];
  };

  self.enrollInCourse = () => {
    Kadenze.Analytics.mpTrack('Start Enrollment Process', self.trackingData());
    self.loginOrRegister().done(function () {
      self.enroll();
    });
  };

  self.upgradeUser = function() {
    Kadenze.Analytics.mpTrack('Start Upgrade Process', self.trackingData());
    window.location = Kadenze.Routes.shop_plans_path();
  };

  self.enroll = function() {
    let $container = $('body');
    Kadenze.UIUtil.showLoadingIndicator($container);

    // We should track enrollment here, but should be different from course info/program info page

    let enrollment_type;
    if(self.premium_member) {
      enrollment_type = 'certificate_track';
    } else {
      enrollment_type = 'auditor';
    }

    Kadenze.Analytics.mpTrack('Submit Enrollment Request', _.extend({}, self.trackingData(), {enrollment_type: enrollment_type}));

    let req = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.course_enroll_path(self.course_id),
      data: { type: enrollment_type }
    });

    req.done(function(res) {
      location.reload();
    });

    req.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.errors;
      }
      new Kadenze.Notice.error({message: msg});
      Kadenze.UIUtil.hideLoadingIndicator($container);
    });
  };

  self.loginOrRegister = function () {
    let deferred = $.Deferred();
    if (self.user_type == 'public') {
      let $el = $('#js-course-enroll-modal--authenticate');
      let args = {
        onLogin: function (response) {
          deferred.resolve();
          $el.modal('hide');
        },
        onRegister: function (response) {
          deferred.resolve();
          Kadenze.Analytics.track('student_ui', 'enrollment_started', { source_medium: 'session_detail' });

          $el.modal('hide');
        },
        trackingData: self.trackingData()
      };

      let vm = new LoginModal(args);
      ko.cleanNode($el[0]);
      ko.applyBindingsWithValidation(vm, $el[0], _.extend({}, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS, {insertMessages: false}));

      $el.on('shown.bs.modal', function(){
        vm.initSSOEvents();
      });
      $el.modal('show');
    } else {
      deferred.resolve();
    }
    return deferred;
  };

  self.showShareModal = function(item, event) {
    let share_url = `https://${window.location.host}${Kadenze.Routes.course_session_path(item.course_id, item.id)}?utm_source=kadenze&utm_medium=share&utm_campaign=session_share&utm_content=session_id=${item.id}`;
    let params = {
      modal_title: 'Share Session',
      shareableObj: {
        id: item.id,
        course_id: item.course_id,
        title: 'Kadenze',
        description: 'Kadenze brings together educators, artists, and engineers from leading universities to provide world-class education in the fields of art and creative technology.',
        share_url: share_url
      },
      emailShareCb: self.shareLecture
    };
    let modal = new Kadenze.ShareModal(params);
    modal.show();
    Kadenze.Analytics.mpTrack('Start Sharing', self.trackingData());
  };

  self.shareLecture = function(item, emails) {
    // Kadenze.Analytics.mpTrack('Share', _.extend({}, self.trackingData(), {share_type: 'email'}));
    // var request = new Kadenze.AjaxRequest({
    //   type: 'POST',
    //   url: Kadenze.Routes.share_course_session_path(item.course_id, item.id),
    //   data: {emails: emails}
    // });

    // request.done(function(res) {
      console.log("This feature is not available for now.");
    // });

    // request.fail(function(xhr, status, msg) {
    //   if (xhr.responseJSON) {
    //     msg = xhr.responseJSON.message;
    //   }
    //   new Kadenze.Notice.error({message: msg});
    // });
  };

  self.trackingData = function() {
    return _.extend({}, self.tracking_data, {source_page: 'session view', object_type: 'lecture'});
  };

  self.updateScrolledUserState = function(scrollPercent) {
    const request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: Kadenze.Routes.user_states_path({stateable_id: self.id, stateable_type: 'Lecture'})
    });

    request.done(function(data, status, xhr) {
      if (data['user_state']['meta_data']['scrolled_percent'] != 100) {
        new Kadenze.AjaxRequest({
          type: 'POST',
          url: Kadenze.Routes.user_states_path(),
          data: { user_state: { stateable_id: self.id, stateable_type: 'Lecture', data: JSON.stringify({scrolled_percent: scrollPercent}) }}
        });
      }
    });
  };

  self.calcScrolledPercent = _.debounce((e) => {
    const scrollTop = $(window).scrollTop();
    const docHeight = $(document).height();
    const winHeight = $(window).height();
    const scrollPercent = (scrollTop) / (docHeight - winHeight);
    const scrollPercentRounded = Math.round(scrollPercent * 100);
    self.updateScrolledUserState(scrollPercentRounded);
    if (scrollPercentRounded == 100)
      $(window).unbind('scroll');
  }, 600);

  const __construct = function(that) {
    console.log('constructor called for video lecture view model');
    Kadenze.Analytics.mpTrack('Session View', self.trackingData());

    let vidJson = $('#video_json').val();
    that.tracking_data = JSON.parse($('#tracking_json').val());
    if (vidJson && vidJson.replace(/\s+/, '').length > 0) {
      var jsObj = ko.mapping.fromJSON(vidJson);
      self.media = jsObj.videos;
      // don't call showNextLecture as a function, it is passed as a callback
      initializeDefaults(self.media, showNextLecture);
    }

    let attachmentmapping = {
      'create': function(options) {
        return new FileVM(options.data);
      }
    };
    let attachmentJson = $('#attachments_json').val();
    if (attachmentJson && attachmentJson.replace(/\s+/, '').length > 0) {
      let mapped_attachments = ko.mapping.fromJSON(attachmentJson, attachmentmapping);
      that.attachments(mapped_attachments());
    }

    //monitor page changes on navigation
    let stopOnNav = function() {
      if(self.currentVideo && self.currentVideo.renderer) {
        if(_.isFunction(self.currentVideo.renderer.stop))
          self.currentVideo.renderer.stop();
        self.currentVideo.renderer.hide();
      }
    };

    $('.js-signup-modal').on('click', function() {
      that.enrollInCourse();
    });

    $(window).on('unload', stopOnNav);
    $(document).on('pjax:click page:before-unload', stopOnNav);

    if (self.user_id && parseInt($('#scrolled_percent').val()) != 100) {
      $(window).scroll(self.calcScrolledPercent);
    }

  }(this);
}
